import parrot from '../../assets/images/parrot-cutout.png';
import parrotBitesize from '../../assets/images/parrot-cutout-bitesize.png';
import {useTranslation} from 'react-i18next';

const ParrotBox = ({ text = '', bitesize = false }) => {
  const {t: translate } = useTranslation();
  const url = bitesize ? parrotBitesize : parrot;
  
  return (
    <div className={`parrot-box ${bitesize ? 'parrot-box--bitesize' : ''}`}>
      <img src={url} alt="golingo Parrot" />
      <div className="parrot-box__text">
        {bitesize && <strong>{translate('lesson-tip')} </strong>}
        {text}
      </div>
    </div>
  );
};

export default ParrotBox;
